import { render, staticRenderFns } from "./BLBedrijventerreinLayer.vue?vue&type=template&id=4e5fd9be"
import script from "./BLBedrijventerreinLayer.vue?vue&type=script&lang=js"
export * from "./BLBedrijventerreinLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports